import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Trash2 } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="bg-green-700 text-white text-sm py-2 px-4 flex justify-between items-center">
        <span className="hidden sm:block font-medium">📍 Serving Dublin, Meath, Louth & Kildare</span>
        <a
          href="tel:0852730131"
          className="flex items-center gap-2 font-bold text-base hover:text-green-200 transition-colors ml-auto"
        >
          <Phone size={16} />
          085 273 0131
        </a>
      </div>

      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-lg' : 'bg-white shadow-md'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="bg-green-600 rounded-full p-2 group-hover:bg-green-700 transition-colors">
                <Trash2 size={24} className="text-white" />
              </div>
              <div>
                <div className="text-green-800 font-black text-lg leading-tight tracking-tight">LAWLOR</div>
                <div className="text-gray-600 font-semibold text-xs tracking-widest uppercase leading-tight">Rubbish Removal</div>
              </div>
            </Link>

            <div className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`nav-link px-4 py-2 rounded-lg font-semibold text-sm transition-all duration-200 ${
                    isActive(link.to)
                      ? 'text-green-600 bg-green-50'
                      : 'text-gray-700 hover:text-green-600 hover:bg-green-50'
                  } ${isActive(link.to) ? 'active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:0852730131"
                className="ml-4 bg-green-600 hover:bg-green-700 text-white font-bold px-5 py-2.5 rounded-full flex items-center gap-2 transition-all duration-200 pulse-green text-sm"
              >
                <Phone size={16} />
                Free Quote
              </a>
            </div>

            <button
              className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 shadow-xl">
            <div className="px-4 py-4 space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`block px-4 py-3 rounded-lg font-semibold text-sm transition-colors ${
                    isActive(link.to)
                      ? 'text-green-600 bg-green-50'
                      : 'text-gray-700 hover:text-green-600 hover:bg-green-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:0852730131"
                className="block mt-3 bg-green-600 hover:bg-green-700 text-white font-bold px-4 py-3 rounded-lg text-center transition-colors"
              >
                📞 Call: 085 273 0131
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
